export default {
  computed: {
    params() {
      const query = this.$route.query || {}
      const data = {}

      /** se completa cualquier otro parametro que venga en la url que no sea utm_ */
      Object.keys(query)
        .filter((key) => !key.startsWith('utm_'))
        .forEach((key) => {
          data[key] = query[key]
        })

      /** en `layouts/default.vue` se almacena la info correspondiente a utm_ ...se trabaja las paginas de influencer por independiente */
      try {
        if (localStorage) {
          const items = JSON.parse(localStorage.getItem('lad-utm'))

          for (const [key, value] of Object.entries(items.utm)) {
            data[key] = value
          }
        }
      } catch (error) {}

      return data
    },
  },
}
